import { FC, CSSProperties } from 'react';
import classNames from 'classnames';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '../uiLibraryImports';
import styles from './dialog.module.scss';

const DialogContainer: FC<DialogContainerProps> = (props: DialogContainerProps) => {
    const {
        title,
        onClose,
        open,
        content,
        subTitle,
        className,
        style,
        dataTestid,
        okButtonOnClick,
        okButtonText,
        cancelButtonText,
        cancelButtonOnClick
    } = props;

    return (
        <Dialog
            onClose={(e: object): void => onClose(e)}
            open={open}
            style={style}
            keepMounted
            fullWidth
            data-testid={dataTestid}
            className={classNames(className, styles.dialog)}
        >
            <DialogTitle>
                <div className={styles['dialog-title']} id="dialog-title">
                    {title}
                </div>
            </DialogTitle>
            <DialogContent>
                {subTitle && (
                    <DialogContentText className={styles['dialog-sub-title']} id="dialog-sub-title">
                        {subTitle}
                    </DialogContentText>
                )}
                <DialogContentText id="dialog-content">{content}</DialogContentText>
            </DialogContent>
            {okButtonText && (
                <DialogActions>
                    {cancelButtonText && (
                        <Button
                            onClick={cancelButtonOnClick ? () => cancelButtonOnClick() : () => undefined}
                            className={styles['cancel-button']}
                            id="cancel-button"
                        >
                            {cancelButtonText}
                        </Button>
                    )}
                    <Button onClick={() => okButtonOnClick?.()} className={styles['ok-button']} id="ok-button">
                        {okButtonText}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

interface DialogContainerProps {
    title: string;
    subTitle?: string;
    content: string;
    open: boolean;
    onClose: Function;
    className?: string;
    style?: CSSProperties | undefined;
    dataTestid?: string;
    okButtonText?: string;
    okButtonOnClick?: Function;
    cancelButtonText?: string;
    cancelButtonOnClick?: Function;
}

export default DialogContainer;
